import { Api } from "../config/request";

export default {
  getCashTransactionsList(queryParams) {
    return Api.get(`/driver-accounting/cash-transactions${queryParams}`);
  },
};
